import { Text, Icon, Image, Badge, PlainLink, Box, Paragraph } from '@customerio/pluma-components/react';
import type { ActionIcon, AddPeopleAction } from '../actions';
import * as styles from '../styles.css';

type ActionIconBubblesProps = {
  icons: ActionIcon[];
};

function ActionIconBubbles({ icons }: ActionIconBubblesProps) {
  return (
    <div className={styles.iconBubblesContainer}>
      {icons.map((icon, index) => (
        <div key={index} className={styles.iconBubble} style={{ zIndex: icons.length - index }}>
          {icon.type === 'text' ? (
            icon.value
          ) : icon.type === 'icon' ? (
            <Icon name={icon.value} size="lg" />
          ) : (
            <Image src={icon.value} alt={icon.alt ?? ''} size="icon-v2-lg" />
          )}
        </div>
      ))}
    </div>
  );
}

type AddPeopleActionCardProps = {
  action: AddPeopleAction;
  onClickAction: (title: string) => void;
};

export function AddPeopleActionCard({ action, onClickAction }: AddPeopleActionCardProps) {
  return (
    <PlainLink
      href={action.href}
      className={styles.actionCard}
      data-test-add-people-button={action.title}
      onClick={() => onClickAction(action.title ?? 'Other')}
    >
      <ActionIconBubbles icons={action.icons} />
      {action.title != null ? (
        <Text weight="bold" display="block" mb="050">
          {action.title}
        </Text>
      ) : null}
      <Paragraph color="subtle" flexGrow="1">
        {action.description}
      </Paragraph>
      {action.recommended === true ? (
        <Box mt="100">
          <Badge color="green" showStatusIndicator={true}>
            Recommended
          </Badge>
        </Box>
      ) : null}
    </PlainLink>
  );
}
